//@ts-check

import React, { useState, useCallback } from "react";
import mbFetch from "mibaby-common/util/fetch";
import debounce from "@util/debounce";
import { useImmer } from "@util/hooks/useImmer";
import TeaserStatisticsContext from "./TeaserStatisticsContext";

const useStatistics = (initialStats = {}) => {
  const [state, update] = useImmer({
    pending: [],
    statsById: initialStats,
  });

  const scheduleWorker = useCallback(
    debounce(async () => {
      let ids;
      update(draft => {
        ids = draft.pending.slice();
        draft.pending = [];
      });

      const data = await (
        await mbFetch("/content_feeds/stats", {
          method: "POST",
          body: JSON.stringify(ids),
        })
      ).json();

      update(draft => {
        Object.assign(draft.statsById, data);
      });
    }, 1),
    []
  );

  const addRequest = useCallback(id => {
    update(draft => {
      if (!!id && !draft.statsById[id]) {
        draft.statsById[id] = { status: "loading" };
        draft.pending.push(id);
      }
    });
    scheduleWorker();
  }, []);

  return [state, addRequest];
};

export const TeaserStatisticsProvider = ({
  initialStats = {},
  initialStatsVisisble = false,
  ...props
}) => {
  const [statsVisible, setStatsVisible] = useState(initialStatsVisisble);
  const [{ statsById }, request] = useStatistics(initialStats);

  const showStats = useCallback(
    toggle => setStatsVisible(prev => (toggle === undefined ? !prev : toggle)),
    []
  );

  return (
    <TeaserStatisticsContext.Provider
      {...props}
      value={{
        request,
        showStats,
        statsVisible,
        statsById,
      }}
    />
  );
};
